@if (!standalone) {
  <kb-control-container
    [showError]="showError"
    [controlId]="comboboxId"
    #controlContainerElement
  >
    <ng-container *ngTemplateOutlet="selectTemplate; context: {controlContainerElement:controlContainerElement}" />
    <kb-label><ng-content select="kb-label" /> {{required && showRequired ? ' *' : ''}}</kb-label>
    <ng-content select="kb-hint" ngProjectAs="kb-hint" />
    <ng-content select="kb-error" ngProjectAs="kb-error" />
  </kb-control-container>
} @else {
  <ng-container [ngTemplateOutlet]="selectTemplate" />
}

<ng-template #selectTemplate let-controlContainerElement="controlContainerElement">
  <div
    class="container"
    [class.open]="open"
  >
    <div
      [id]="comboboxId"
      class="selected"
      (click)="open = !open"
      (keyup.enter)="open = !open"
      (focus)="onFocus()"
      (blur)="onBlur($event)"
      role="combobox"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="controlContainerElement ? controlContainerElement.labelId : ariaLabelledby"
      [attr.aria-describedby]="controlContainerElement ? controlContainerElement.hintElement?.id : null"
      [attr.aria-controls]="listboxId"
      [attr.aria-expanded]="open ? 'true' : undefined"
      [attr.aria-activedescendant]="ariaActiveDescendant"
      aria-haspopup="listbox"
      [tabindex]="this.disabled ? '-1' : '0'"
      #comboboxElement
    >
      @if (selectedOption) {
        <ng-container *ngTemplateOutlet="selectedOption.selectedTemplate ?? selectedOption.label" />
      }
      <kb-icon class="open-close-icon" [icon]="iconArrowDown" icon-uppercase icon-center />
    </div>
    <div class="panel">
      <div
        class="options kb-scrollbar"
        role="listbox"
        [id]="listboxId"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="controlContainerElement ? controlContainerElement.labelId : ariaLabelledby"
        tabindex="-1"
        (click)="onOptionsPanelClick()"
        (keyup.enter)="onOptionsPanelClick()"
        #optionsPanel
      >
        <ng-content />
      </div>
    </div>
  </div>
</ng-template>
